/* eslint-disable no-undef */
export const delay = (function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

export const buildApplicationDataObject = (vData) => {
  const t = (val) => val ?? "";
  const dataObject = {
    qdbapi: {
      udata: "DiscoverHousing_QuestionnaireResponses",
      field: [
        // Tenant Info
        {
          _fid: "6",
          __text: t(vData.adultsPath),
        },
        {
          _fid: "7",
          __text: t(vData.childPath),
        },
        {
          _fid: "8",
          __text: t(vData.incomePath),
        },
        {
          _fid: "9",
          __text: t(vData.yearsPath),
        },
        {
          _fid: "10",
          __text: t(vData.disabilityPath),
        },
        {
          _fid: "11",
          __text: t(vData.primaryResidencePath),
        },
        {
          _fid: "12",
          __text: t(vData.homeownerPath),
        },
        {
          _fid: "13",
          __text: t(vData.spropertyPath),
        },
        {
          _fid: "14",
          __text: t(vData.deedPath),
        },
        {
          _fid: "15",
          __text: t(vData.applicantInterestedList),
        },
        {
          _fid: "16",
          __text: t(vData.Name),
        },
        {
          _fid: "18",
          __text: t(vData.Address.Street1),
        },
        {
          _fid: "19",
          __text: t(vData.Address.Street2),
        },
        {
          _fid: "20",
          __text: t(vData.Address.City),
        },
        {
          _fid: "21",
          __text: t(vData.Address.State),
        },
        {
          _fid: "22",
          __text: t(vData.Address.Zip),
        },
        {
          _fid: "24",
          __text: t(vData.Phone),
        },
        {
          _fid: "25",
          __text: t(vData.EmailAddress),
        },
        // {
        //   _fid: "26",
        //   __text: vData.applicantInterestedEmailFormat, //check if needed
        // },
        {
          _fid: "31",
          __text: t(vData.referralPath),
        },
        {
          _fid: "32",
          __text: t(vData.TripleRSelection),
        },
        {
          _fid: "38",
          __text: t(vData.employeePath),
        },
        {
          _fid: "39",
          __text: t(vData.roofLeakPath),
        },
        {
          _fid: "40",
          __text: t(vData.electricProblemPath),
        },
        {
          _fid: "41",
          __text: t(vData.plumbingProblemPath),
        },
        {
          _fid: "42",
          __text: t(vData.structuralProblemPath),
        },
        {
          _fid: "43",
          __text: t(vData.floorStairsPath),
        },
        {
          _fid: "44",
          __text: t(vData.heaterOrHotWaterPath),
        },
        {
          _fid: "45",
          __text: t(vData.helpInHomePath),
        },
        {
          _fid: "46",
          __text: t(vData.tangleTitlePath),
        },
        {
          _fid: "47",
          __text: t(vData.solarPowerPath),
        },
        {
          _fid: "48",
          __text: t(vData.billProblemPath),
        },
        // {
        //   _fid: "49",
        //   _text: vData.shiaEmail,
        // },
      ],
    },
  };
  return dataObject;
};

export const dataObjectToXml = (dataObject) => {
  const options = { compact: true, ignoreComment: true, spaces: 4 };
  var xml2Json = new X2JS();
  return xml2Json.json2xml_str(dataObject, options);
};

export const getPropertyValueOrDefault = (p, o) =>
  p.reduce((xs, x) => (xs && xs[x] ? xs[x] : null), o);
